import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=c70b8434&scoped=true&"
import script from "./confirmDialog.vue?vue&type=script&lang=js&"
export * from "./confirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./confirmDialog.vue?vue&type=style&index=0&id=c70b8434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70b8434",
  null
  
)

export default component.exports